import gsap from 'gsap'

export let destroyCursor

export const initCursor = (container) => {

	const trailer = document.querySelector('.trail-cursor')

	if (trailer || container === 'about') {
		setupCursor()
	} else {
		destroyCursor()
	}

	function setupCursor() {
		const images = document.querySelectorAll('.trail-cursor__image')

		let currentImageIndex = 0
		let lastMousePos = { x: 0, y: 0 }
		let lastImageTime = Date.now()
	
		const movementThreshold = 120 // minimum pixels mouse must move before creating a new image
		const delayBetween = 120 // minimum time (ms) between creating new images
	
		function createImageTrail(e) {
			const dx = e.clientX - lastMousePos.x
			const dy = e.clientY - lastMousePos.y
			const distance = Math.sqrt(dx * dx + dy * dy)
	
			if (distance < movementThreshold) return
	
			const now = Date.now()
			if (now - lastImageTime < delayBetween) return
	
			const image = images[currentImageIndex].cloneNode()
	
			currentImageIndex = (currentImageIndex + 1) % images.length
	
			// Position the image centered on the cursor
			image.style.left = `${e.clientX - 90}px`
			image.style.top = `${e.clientY - 75}px`
	
			// Add the cloned image to the trailer container
			trailer.appendChild(image)
	
			// Animate the image appearing: scale from 0 → 1, no opacity change
			gsap.fromTo(image, {
				opacity: 1, // set to 0 if you want fade in
				scale: 0, // start scaled down
				rotation: gsap.utils.random(-20, 20) // small random tilt
			}, {
				opacity: 1, // remain fully visible
				scale: 1, // grow to full size
				duration: 0.6, // animation duration
				ease: 'back.out(2)' // bouncy entrance
			})
	
			// Animate the image shrinking out (scale → 0), opacity stays 1
			gsap.to(image, {
				opacity: 1, // set to 0 if you want the fade out animation
				scale: 0, // shrink to nothing
				duration: 0.6, // animation duration
				delay: 0.3, // wait before starting shrink
				ease: 'power2.in', // smooth shrinking
				onComplete: () => image.remove() // remove from DOM after animation
			})
	
			// Save current mouse position & time for next calculation
			lastMousePos = { x: e.clientX, y: e.clientY }
			lastImageTime = now
		}
	
		document.addEventListener('mousemove', createImageTrail)
	}

	destroyCursor = () => {
		document.removeEventListener('mousemove', createImageTrail)
		document.querySelectorAll('.trail-cursor img').forEach(image => image.remove())
	}
}

export default () => {}
